import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons'
import MyDrawer from './myDrawer'
import SearchHeaderContainer from '../../containers/SearchHeaderContainer'
import { RESUMEN_PEDIDO_DRAWER_WIDTH } from '../../config/layoutConstants'

const drawerWidth = 240
const styles = theme => ({
  appBar: {
    height: '80px',
    background: '#ffffff',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
    zIndex: 100
  },
  menuButtonColor: {
    color: '#FFFFFF !important'
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: theme.spacing.unit * 7 + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9 + 1
    }
  },
  root: {
    flexGrow: 1
  },
  show: {
    transform: 'translateY(0)',
    transition: 'transform .5s'
  },
  hideTop: {
    transform: 'translateY(-175%)',
    transition: 'transform .5s'
  },
  tooltipCalendar: {
    pointerEvents: 'auto',
    maxWidth: 200
  }
})

class Header extends React.Component {
  constructor (props) {
    super(props)

    // verifica si debe mostrar el tooltip del calendario
    if (this.props.usuario) {
      const showPopOverCalendarioKey = this.props.usuario.id + '_showPopOverCalendario'
      localStorage.setItem(showPopOverCalendarioKey, true)
    }

    this.state = {
      shouldShow: null,
    }

    this.lastScroll = null

    this.handleScroll = this.handleScroll.bind(this)
    // Alternatively, you can throttle scroll events to avoid
    // updating the state too often. Here using lodash.
    // this.handleScroll = _.throttle(this.handleScroll.bind(this), 100);
  }

  componentDidMount () {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll (evt) {
    const { scrollY } = window
    const lastScroll = scrollY

    if (lastScroll === this.lastScroll) {
      return
    }

    const shouldShow = (this.lastScroll !== null) ? (lastScroll < this.lastScroll) : null

    if (shouldShow !== this.state.shouldShow && Math.abs((lastScroll - this.lastScroll)) > 15) {
      this.setState((prevState, props) => ({
        ...prevState,
        shouldShow
      }))
    }

    this.lastScroll = lastScroll
  }

  render () {
    const { classes } = this.props

    const withResumen = this.props.pedido !== undefined && this.props.showResumenPedido === true

    return (
      <div
        className={`menuSuperior ${withResumen ? 'appWithResumePedido' : ''}`}
        style={{ '--resumen-pedido-drawer-width': `${RESUMEN_PEDIDO_DRAWER_WIDTH}px` }}
      >
        <AppBar
          position="fixed"
          className={classNames(classes.appBar, {
            [classes.appBarShift]: this.props.drawerOpen
          }, `${classes.root} ${
            this.state.shouldShow === null ? '' : (
              this.state.shouldShow ? classes.show : classes.hideTop
            )
            }`)}
        >
          <Toolbar disableGutters={!this.props.drawerOpen}>

            {/* ícono para el drawer */}
            {this.props.showDrawer &&
              <div onClick={this.props.handleDrawerOpen}
              className={classNames(classes.menuButton, classes.menuButtonColor, { [classes.hide]: this.props.drawerOpen }, 'headerButton')}>
                <div style={{ position: 'relative' }}>
                  <img alt="" src={require('../../images/menu.svg')}></img>
                </div>
              </div>}

            {/* ícono para volver */}
            {this.props.showBackButton &&
              <IconButton
                color="default"
                aria-label="Back"
                className={classNames(classes.menuButton, 'headerButton')}
                onClick={this.props.handleOnBackClick}
              >
                <ArrowBackIcon />
              </IconButton>
            }

            {/* logo */}
            {!this.props.drawerOpen &&
              <div /* style={{display: 'none'}} */ onClick={() => { this.props.handleOnClickLogo() }} className={`logoContainer center ${this.props.pedido ? 'logoContainerAux' : ''}`}>
                {/* <img alt="" src={this.props.instalacion.logoSuperior} /> */}
                <img alt="" src={require('../../images/logoDrawer.png')} />
              </div>}

              {/* <div className='labelTest'>TEST</div> */}

              {/* buscador */}

              {this.props.showBusqueda === true &&
              <SearchHeaderContainer
                pedido={this.props.pedido}
                filterArticulos={this.props.filterArticulos}
                handleOnChangeFilter={this.props.handleOnChangeFilter}
                handleOnClearBusqueda={this.props.handleOnClearBusqueda}
              />}

              <div className='containerIconsHeader'>
              {/* ICONO FAVORITOS */}
              
              {/* <div onClick={this.props.handleOnClickFavoritos}>
                  <FavoriteBorderIcon className='iconFav'/>
              </div> */}
              {this.props.pedido !== undefined &&
              <div className='verCarritoContainer' onClick={this.props.handleOnClickVerCarrito}>
                <div style={{ position: 'relative' }}>
                  <img alt="" src={require('../../images/carrito.svg')}></img>
                  <div className='cantidadCarrito'>
                    {this.props.pedido.listaPedidoDetalle && this.props.pedido.listaPedidoDetalle.length > 0 ? this.props.pedido.listaPedidoDetalle.length : undefined}
                  </div>
                </div>
              </div>}
              </div>
          </Toolbar>

          {/* contenido extra */}
          {this.props.contenidoExtra &&
            <div id='headerContenidoExtra'>
              {this.props.contenidoExtra}
            </div>
          }
        </AppBar>

        {/* menú lateral */}
        {this.props.showDrawer &&
          <MyDrawer
            drawerOpen={this.props.drawerOpen}
            handleDrawerClose={this.props.handleDrawerClose}
            instalacion={this.props.instalacion}
            preguntasFrecuentes={this.props.preguntasFrecuentes}
            handleOnCerrarSesion={this.props.handleOnCerrarSesion}
            handleOnClickLogo={this.props.handleOnClickLogo}
            handleOnClickIniciarSesion={this.props.handleOnClickIniciarSesion}
            usuario={this.props.usuario}
            handleOnClickOpenNotidicaciones={this.props.handleOnClickOpenNotidicaciones}
            handleOnClickBasesCondiciones={this.props.handleOnClickBasesCondiciones}
          />
        }
      </div>
    )
  }
}

Header.propTypes = {
  showDrawer: PropTypes.bool.isRequired,
  drawerOpen: PropTypes.bool.isRequired,
  handleDrawerOpen: PropTypes.func.isRequired,
  handleDrawerClose: PropTypes.func.isRequired,
  showBackButton: PropTypes.bool.isRequired,
  handleOnBackClick: PropTypes.func,
  instalacion: PropTypes.object.isRequired,
  contenidoExtra: PropTypes.node,
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,

  preguntasFrecuentes: PropTypes.object,
  usuario: PropTypes.object,
  handleOnCerrarSesion: PropTypes.func.isRequired,
  handleOnClickLogo: PropTypes.func.isRequired,
  showResumenPedido: PropTypes.bool.isRequired,
  filterArticulos: PropTypes.string.isRequired,
  handleOnChangeFilter: PropTypes.func.isRequired,
  handleOnClearBusqueda: PropTypes.func.isRequired,
  handleOnClickIniciarSesion: PropTypes.func.isRequired,
  handleOnClickVerCarrito: PropTypes.func.isRequired,
  showBusqueda: PropTypes.bool.isRequired,
  handleOnClickBasesCondiciones: PropTypes.func.isRequired,

  handleOnClickOpenModalRubros: PropTypes.func.isRequired,
  handleOnClickOpenNotidicaciones: PropTypes.func.isRequired,
  handleOnClickFavoritos: PropTypes.func.isRequired

}

Header.defaultProps = {
  showResumenPedido: false,
  showDrawer: false,
  drawerOpen: false,
  handleDrawerOpen: f => f,
  handleDrawerClose: f => f,
  showBackButton: false,
  handleOnBackClick: f => f,
  handleOnChangeFilter: f => f,
  handleOnClickBasesCondiciones: f => f,
  handleOnClickOpenModalRubros: f => f,
  handleOnClickOpenNotidicaciones: f => f,
  handleOnClickFavoritos: f => f
}

export default withStyles(styles, { withTheme: true })(Header)
